import {
  AuthType,
  BodyContentType,
  BodyType,
  SourceType,
  DefaultValues,
  RequestMethod,
  ResponseMode,
} from "../constants/restRequestConstants";

import isEmpty from 'lodash/isEmpty';

export const createEmptyRestRequest = () => ({
  runId: null,
  method: RequestMethod.GET,
  url: "",
  validateSSL: true,
  followRedirects: true,
  maxRedirects: DefaultValues.MAX_REDIRECTS,
  persistCookies: false,
  headers: [
    // {
    //   key: '',
    //   value: '',
    //   enabled: true,
    // }
  ],
  queryParams: [
    // {
    //   key: '',
    //   value: '',
    //   enabled: true,
    // }
  ],
  auth: {
    type: AuthType.NONE, // 'none', 'basic', 'bearer', 'apiKey', 'oauth2'
    credentialId: "",

    addTo: null, // 'header' or 'query' (for apiKey)

    // Basic auth. Used when type='basic'
    usernameKeyName: "username",
    passwordKeyName: "password",

    // API Key. Used when type='apiKey'
    apiKeyName: "apiKey",

    // OAuth2. Used when type='oauth2'
    clientIdKeyName: "client_id",
    clientSecretKeyName: "client_secret",
    grantType: "client_credentials",
    tokenUrl: null,
    scope: null,
  },
  body: {
    type: BodyType.NONE, // 'raw', 'formData', 'urlEncoded' or 'none'
    contentType: BodyContentType.JSON,
    raw: "",
    formData: [

      // The UI expects the format defined in restRequestConstants.ITEM_TEMPLATE

      // The server expects the following format,
      // which is constructed in `prepareRequest`
      // and `resolveFormData`. The file must be added to a FormData object
      // with the key of the fieldName.
      // {
      //   key: 'fieldName',      // Form field name
      //   value: 'fieldValue',   // Text value or file reference
      //   type: 'text',          // 'text' or 'file'
      //   enabled: true
      // }
    ],
    urlEncoded: [
      // {
      //   key: 'paramName',
      //   value: 'paramValue',
      //   enabled: true
      // }
    ],
  },
  response: {
    //expectedStatus: [200],
    expectedStatus: [],
    enableTimeout: false,
    timeoutDuration: DefaultValues.TIMEOUT,
    retryOnFailure: false,
    maxRetries: DefaultValues.MAX_RETRIES,
    responseMode: ResponseMode.STANDARD,
  },
  mappings: [],
  envVars: [],
});


export const validateRestRequest = (request) => {
  if (!request?.method || !request?.url) {
    return false;
  }

  // Only validate the request if the URL is not empty for now
  // This validation is only used to disable the "Test Button" in the UI
  return true;

  // Leaving this code for now. We can use this later if we need to validate the request fully
  if (request.headers?.length > 0) {
    if (!request.headers.every((header) => _validateItemWithSource(header))) {
      return false;
    }
  }

  if (request.queryParams?.length > 0) {
    if (!request.queryParams.every((param) => _validateItemWithSource(param))) {
      return false;
    }
  }

  if (request.auth?.type && request.auth.type !== AuthType.NONE) {
    if (!_validateAuth(request.auth)) {
      return false;
    }
  }

  if (request.body?.type) {
    if (request.body.type === BodyType.RAW) {
      if (!request.body.contentType) {
        return false;
      }
    } else if (request.body.type === BodyType.FORM 
                && request.body.urlEncoded?.length > 0) {
      if (!request.body.urlEncoded.every((item) => _validateItemWithSource(item))) {
        return false;
      }
    } else if (request.body.type === BodyType.MULTIPART && request.body.formData?.length > 0) {
      if (!request.body.formData.every((item) => _validateItemWithSource(item))) {
        return false;
      }
    }
  }

  if (request.envVars?.length > 0) {
    if (!request.envVars.every((envVar) => _validateItemWithSource(envVar))) {
      return false;
    }
  }

  // if (request.mappings?.length > 0) {
  //   if (!request.mappings.every((mapping) => mapping.fieldId && mapping.responsePath)) {
  //     return false;
  //   }
  // }

  return true;
};

const _validateItemWithSource = (item) => {
  if (item.enabled === false) {
    return true;
  }

  if (!item.key) {
    return false;
  }

  if (item.source === SourceType.FIELD || item.source === SourceType.SERVER_VARIABLE) {
    return !!item.fieldId || !isEmpty(item.testValue);
  } else if (item.source === SourceType.CREDENTIAL) {
    return !!item.credentialId || !isEmpty(item.testValue);
  } else if (item.source === SourceType.ATTACHMENT) {
    return !!item.fieldId || !isEmpty(item.testFile);
  } else {
    return !isEmpty(item.value);
  }
};

const _validateAuth = (auth) => {
  switch (auth.type) {
    case AuthType.BASIC:
    case AuthType.BEARER:
    case AuthType.API_KEY:
    case AuthType.OAUTH2:
      return !!auth.credentialId;
    case AuthType.NONE:
    case AuthType.USER_TOKEN:
      return true;
    default:
      return false;
  }
};


export const getAuthValueType = (authType) => {
  switch (authType) {
    case AuthType.BASIC:
    case AuthType.OAUTH2:
      return "username-password";
    case AuthType.BEARER:
      return "bearerToken";
    case AuthType.API_KEY:
      return "apiKey";
    case AuthType.USER_TOKEN:
      return "userToken";
    default:
      return "";
  }
};
